import { render, staticRenderFns } from "./HelpInstruction.vue?vue&type=template&id=00052a92&scoped=true&"
import script from "./HelpInstruction.vue?vue&type=script&lang=js&"
export * from "./HelpInstruction.vue?vue&type=script&lang=js&"
import style0 from "./HelpInstruction.vue?vue&type=style&index=0&id=00052a92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00052a92",
  null
  
)

export default component.exports